/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Badge,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  ScrollView,
  Text,
  TextField,
  useTheme,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { API } from "aws-amplify";
import { getCompany } from "../graphql/queries";
import { updateCompany } from "../graphql/mutations";
function ArrayField({
  items = [],
  onChange,
  label,
  inputFieldRef,
  children,
  hasError,
  setFieldValue,
  currentFieldValue,
  defaultFieldValue,
  lengthLimit,
  getBadgeText,
  runValidationTasks,
  errorMessage,
}) {
  const labelElement = <Text>{label}</Text>;
  const {
    tokens: {
      components: {
        fieldmessages: { error: errorStyles },
      },
    },
  } = useTheme();
  const [selectedBadgeIndex, setSelectedBadgeIndex] = React.useState();
  const [isEditing, setIsEditing] = React.useState();
  React.useEffect(() => {
    if (isEditing) {
      inputFieldRef?.current?.focus();
    }
  }, [isEditing]);
  const removeItem = async (removeIndex) => {
    const newItems = items.filter((value, index) => index !== removeIndex);
    await onChange(newItems);
    setSelectedBadgeIndex(undefined);
  };
  const addItem = async () => {
    const { hasError } = runValidationTasks();
    if (
      currentFieldValue !== undefined &&
      currentFieldValue !== null &&
      currentFieldValue !== "" &&
      !hasError
    ) {
      const newItems = [...items];
      if (selectedBadgeIndex !== undefined) {
        newItems[selectedBadgeIndex] = currentFieldValue;
        setSelectedBadgeIndex(undefined);
      } else {
        newItems.push(currentFieldValue);
      }
      await onChange(newItems);
      setIsEditing(false);
    }
  };
  const arraySection = (
    <React.Fragment>
      {!!items?.length && (
        <ScrollView height="inherit" width="inherit" maxHeight={"7rem"}>
          {items.map((value, index) => {
            return (
              <Badge
                key={index}
                style={{
                  cursor: "pointer",
                  alignItems: "center",
                  marginRight: 3,
                  marginTop: 3,
                  backgroundColor:
                    index === selectedBadgeIndex ? "#B8CEF9" : "",
                }}
                onClick={() => {
                  setSelectedBadgeIndex(index);
                  setFieldValue(items[index]);
                  setIsEditing(true);
                }}
              >
                {getBadgeText ? getBadgeText(value) : value.toString()}
                <Icon
                  style={{
                    cursor: "pointer",
                    paddingLeft: 3,
                    width: 20,
                    height: 20,
                  }}
                  viewBox={{ width: 20, height: 20 }}
                  paths={[
                    {
                      d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
                      stroke: "black",
                    },
                  ]}
                  ariaLabel="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    removeItem(index);
                  }}
                />
              </Badge>
            );
          })}
        </ScrollView>
      )}
      <Divider orientation="horizontal" marginTop={5} />
    </React.Fragment>
  );
  if (lengthLimit !== undefined && items.length >= lengthLimit && !isEditing) {
    return (
      <React.Fragment>
        {labelElement}
        {arraySection}
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      {labelElement}
      {isEditing && children}
      {!isEditing ? (
        <>
          <Button
            onClick={() => {
              setIsEditing(true);
            }}
          >
            Add item
          </Button>
          {errorMessage && hasError && (
            <Text color={errorStyles.color} fontSize={errorStyles.fontSize}>
              {errorMessage}
            </Text>
          )}
        </>
      ) : (
        <Flex justifyContent="flex-end">
          {(currentFieldValue || isEditing) && (
            <Button
              children="Cancel"
              type="button"
              size="small"
              onClick={() => {
                setFieldValue(defaultFieldValue);
                setIsEditing(false);
                setSelectedBadgeIndex(undefined);
              }}
            ></Button>
          )}
          <Button size="small" variation="link" onClick={addItem}>
            {selectedBadgeIndex !== undefined ? "Save" : "Add"}
          </Button>
        </Flex>
      )}
      {arraySection}
    </React.Fragment>
  );
}
export default function CompanyUpdateForm(props) {
  const {
    id: idProp,
    company: companyModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    name: "",
    nit: "",
    abbreviation: "",
    address: "",
    phone: "",
    description: "",
    legalRepName: "",
    legalRepContact: "",
    otherContacts: [],
    country: "",
    city: "",
  };
  const [name, setName] = React.useState(initialValues.name);
  const [nit, setNit] = React.useState(initialValues.nit);
  const [abbreviation, setAbbreviation] = React.useState(
    initialValues.abbreviation
  );
  const [address, setAddress] = React.useState(initialValues.address);
  const [phone, setPhone] = React.useState(initialValues.phone);
  const [description, setDescription] = React.useState(
    initialValues.description
  );
  const [legalRepName, setLegalRepName] = React.useState(
    initialValues.legalRepName
  );
  const [legalRepContact, setLegalRepContact] = React.useState(
    initialValues.legalRepContact
  );
  const [otherContacts, setOtherContacts] = React.useState(
    initialValues.otherContacts
  );
  const [country, setCountry] = React.useState(initialValues.country);
  const [city, setCity] = React.useState(initialValues.city);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = companyRecord
      ? { ...initialValues, ...companyRecord }
      : initialValues;
    setName(cleanValues.name);
    setNit(cleanValues.nit);
    setAbbreviation(cleanValues.abbreviation);
    setAddress(cleanValues.address);
    setPhone(cleanValues.phone);
    setDescription(cleanValues.description);
    setLegalRepName(cleanValues.legalRepName);
    setLegalRepContact(cleanValues.legalRepContact);
    setOtherContacts(cleanValues.otherContacts ?? []);
    setCurrentOtherContactsValue("");
    setCountry(cleanValues.country);
    setCity(cleanValues.city);
    setErrors({});
  };
  const [companyRecord, setCompanyRecord] = React.useState(companyModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? (
            await API.graphql({
              query: getCompany.replaceAll("__typename", ""),
              variables: { id: idProp },
            })
          )?.data?.getCompany
        : companyModelProp;
      setCompanyRecord(record);
    };
    queryData();
  }, [idProp, companyModelProp]);
  React.useEffect(resetStateValues, [companyRecord]);
  const [currentOtherContactsValue, setCurrentOtherContactsValue] =
    React.useState("");
  const otherContactsRef = React.createRef();
  const validations = {
    name: [{ type: "Required" }],
    nit: [{ type: "Required" }],
    abbreviation: [],
    address: [],
    phone: [{ type: "Phone" }],
    description: [],
    legalRepName: [],
    legalRepContact: [],
    otherContacts: [],
    country: [],
    city: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          name,
          nit,
          abbreviation: abbreviation ?? null,
          address: address ?? null,
          phone: phone ?? null,
          description: description ?? null,
          legalRepName: legalRepName ?? null,
          legalRepContact: legalRepContact ?? null,
          otherContacts: otherContacts ?? null,
          country: country ?? null,
          city: city ?? null,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await API.graphql({
            query: updateCompany.replaceAll("__typename", ""),
            variables: {
              input: {
                id: companyRecord.id,
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "CompanyUpdateForm")}
      {...rest}
    >
      <TextField
        label="Name"
        isRequired={true}
        isReadOnly={false}
        value={name}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name: value,
              nit,
              abbreviation,
              address,
              phone,
              description,
              legalRepName,
              legalRepContact,
              otherContacts,
              country,
              city,
            };
            const result = onChange(modelFields);
            value = result?.name ?? value;
          }
          if (errors.name?.hasError) {
            runValidationTasks("name", value);
          }
          setName(value);
        }}
        onBlur={() => runValidationTasks("name", name)}
        errorMessage={errors.name?.errorMessage}
        hasError={errors.name?.hasError}
        {...getOverrideProps(overrides, "name")}
      ></TextField>
      <TextField
        label="Nit"
        isRequired={true}
        isReadOnly={false}
        value={nit}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              nit: value,
              abbreviation,
              address,
              phone,
              description,
              legalRepName,
              legalRepContact,
              otherContacts,
              country,
              city,
            };
            const result = onChange(modelFields);
            value = result?.nit ?? value;
          }
          if (errors.nit?.hasError) {
            runValidationTasks("nit", value);
          }
          setNit(value);
        }}
        onBlur={() => runValidationTasks("nit", nit)}
        errorMessage={errors.nit?.errorMessage}
        hasError={errors.nit?.hasError}
        {...getOverrideProps(overrides, "nit")}
      ></TextField>
      <TextField
        label="Abbreviation"
        isRequired={false}
        isReadOnly={false}
        value={abbreviation}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              nit,
              abbreviation: value,
              address,
              phone,
              description,
              legalRepName,
              legalRepContact,
              otherContacts,
              country,
              city,
            };
            const result = onChange(modelFields);
            value = result?.abbreviation ?? value;
          }
          if (errors.abbreviation?.hasError) {
            runValidationTasks("abbreviation", value);
          }
          setAbbreviation(value);
        }}
        onBlur={() => runValidationTasks("abbreviation", abbreviation)}
        errorMessage={errors.abbreviation?.errorMessage}
        hasError={errors.abbreviation?.hasError}
        {...getOverrideProps(overrides, "abbreviation")}
      ></TextField>
      <TextField
        label="Address"
        isRequired={false}
        isReadOnly={false}
        value={address}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              nit,
              abbreviation,
              address: value,
              phone,
              description,
              legalRepName,
              legalRepContact,
              otherContacts,
              country,
              city,
            };
            const result = onChange(modelFields);
            value = result?.address ?? value;
          }
          if (errors.address?.hasError) {
            runValidationTasks("address", value);
          }
          setAddress(value);
        }}
        onBlur={() => runValidationTasks("address", address)}
        errorMessage={errors.address?.errorMessage}
        hasError={errors.address?.hasError}
        {...getOverrideProps(overrides, "address")}
      ></TextField>
      <TextField
        label="Phone"
        isRequired={false}
        isReadOnly={false}
        type="tel"
        value={phone}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              nit,
              abbreviation,
              address,
              phone: value,
              description,
              legalRepName,
              legalRepContact,
              otherContacts,
              country,
              city,
            };
            const result = onChange(modelFields);
            value = result?.phone ?? value;
          }
          if (errors.phone?.hasError) {
            runValidationTasks("phone", value);
          }
          setPhone(value);
        }}
        onBlur={() => runValidationTasks("phone", phone)}
        errorMessage={errors.phone?.errorMessage}
        hasError={errors.phone?.hasError}
        {...getOverrideProps(overrides, "phone")}
      ></TextField>
      <TextField
        label="Description"
        isRequired={false}
        isReadOnly={false}
        value={description}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              nit,
              abbreviation,
              address,
              phone,
              description: value,
              legalRepName,
              legalRepContact,
              otherContacts,
              country,
              city,
            };
            const result = onChange(modelFields);
            value = result?.description ?? value;
          }
          if (errors.description?.hasError) {
            runValidationTasks("description", value);
          }
          setDescription(value);
        }}
        onBlur={() => runValidationTasks("description", description)}
        errorMessage={errors.description?.errorMessage}
        hasError={errors.description?.hasError}
        {...getOverrideProps(overrides, "description")}
      ></TextField>
      <TextField
        label="Legal rep name"
        isRequired={false}
        isReadOnly={false}
        value={legalRepName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              nit,
              abbreviation,
              address,
              phone,
              description,
              legalRepName: value,
              legalRepContact,
              otherContacts,
              country,
              city,
            };
            const result = onChange(modelFields);
            value = result?.legalRepName ?? value;
          }
          if (errors.legalRepName?.hasError) {
            runValidationTasks("legalRepName", value);
          }
          setLegalRepName(value);
        }}
        onBlur={() => runValidationTasks("legalRepName", legalRepName)}
        errorMessage={errors.legalRepName?.errorMessage}
        hasError={errors.legalRepName?.hasError}
        {...getOverrideProps(overrides, "legalRepName")}
      ></TextField>
      <TextField
        label="Legal rep contact"
        isRequired={false}
        isReadOnly={false}
        value={legalRepContact}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              nit,
              abbreviation,
              address,
              phone,
              description,
              legalRepName,
              legalRepContact: value,
              otherContacts,
              country,
              city,
            };
            const result = onChange(modelFields);
            value = result?.legalRepContact ?? value;
          }
          if (errors.legalRepContact?.hasError) {
            runValidationTasks("legalRepContact", value);
          }
          setLegalRepContact(value);
        }}
        onBlur={() => runValidationTasks("legalRepContact", legalRepContact)}
        errorMessage={errors.legalRepContact?.errorMessage}
        hasError={errors.legalRepContact?.hasError}
        {...getOverrideProps(overrides, "legalRepContact")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              name,
              nit,
              abbreviation,
              address,
              phone,
              description,
              legalRepName,
              legalRepContact,
              otherContacts: values,
              country,
              city,
            };
            const result = onChange(modelFields);
            values = result?.otherContacts ?? values;
          }
          setOtherContacts(values);
          setCurrentOtherContactsValue("");
        }}
        currentFieldValue={currentOtherContactsValue}
        label={"Other contacts"}
        items={otherContacts}
        hasError={errors?.otherContacts?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("otherContacts", currentOtherContactsValue)
        }
        errorMessage={errors?.otherContacts?.errorMessage}
        setFieldValue={setCurrentOtherContactsValue}
        inputFieldRef={otherContactsRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Other contacts"
          isRequired={false}
          isReadOnly={false}
          value={currentOtherContactsValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.otherContacts?.hasError) {
              runValidationTasks("otherContacts", value);
            }
            setCurrentOtherContactsValue(value);
          }}
          onBlur={() =>
            runValidationTasks("otherContacts", currentOtherContactsValue)
          }
          errorMessage={errors.otherContacts?.errorMessage}
          hasError={errors.otherContacts?.hasError}
          ref={otherContactsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "otherContacts")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Country"
        isRequired={false}
        isReadOnly={false}
        value={country}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              nit,
              abbreviation,
              address,
              phone,
              description,
              legalRepName,
              legalRepContact,
              otherContacts,
              country: value,
              city,
            };
            const result = onChange(modelFields);
            value = result?.country ?? value;
          }
          if (errors.country?.hasError) {
            runValidationTasks("country", value);
          }
          setCountry(value);
        }}
        onBlur={() => runValidationTasks("country", country)}
        errorMessage={errors.country?.errorMessage}
        hasError={errors.country?.hasError}
        {...getOverrideProps(overrides, "country")}
      ></TextField>
      <TextField
        label="City"
        isRequired={false}
        isReadOnly={false}
        value={city}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              nit,
              abbreviation,
              address,
              phone,
              description,
              legalRepName,
              legalRepContact,
              otherContacts,
              country,
              city: value,
            };
            const result = onChange(modelFields);
            value = result?.city ?? value;
          }
          if (errors.city?.hasError) {
            runValidationTasks("city", value);
          }
          setCity(value);
        }}
        onBlur={() => runValidationTasks("city", city)}
        errorMessage={errors.city?.errorMessage}
        hasError={errors.city?.hasError}
        {...getOverrideProps(overrides, "city")}
      ></TextField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || companyModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || companyModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
